const t = [
  "GET",
  "POST",
  "PUT",
  "HEAD",
  "DELETE",
  "PATCH",
  "OPTIONS",
  "CONNECT",
  "TRACE"
];
function T(e) {
  return t.includes(e);
}
export {
  T as isRequestMethod,
  t as validRequestMethods
};
